<template>
  <svg :class="heartClass" class="heart-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 16"><path d="M2.17 1.98C4.05.18 7.1.18 9 3.23 10.89.17 13.95.17 15.83 1.98a4.66 4.66 0 0 1 0 6.69L9 15.25 2.17 8.67a4.66 4.66 0 0 1 0-6.7Z" :fill="isActive ? 'currentColor' : 'transparent'" stroke="currentColor" stroke-width="1" stroke-linejoin="round" /></svg>
</template>

<script>
export default {
  name: 'Heart',
  props: {
    color: {
      type: String,
      default: 'dark',
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    heartClass() {
      return {
        'text-dark': this.color === 'dark',
        'text-light': this.color === 'light',
      };
    },
  },
};

</script>

<style lang="scss" scopped>
  .heart-icon {
    display: block;
    width: 20px;
    height: 19px;
  }
</style>
